import type {
  JobFilterRemoteOption,
  JobSearchFilterCollectionFragment,
  JobSearchFilterCollectionSplitBenefitsFragment,
} from '@/graphql/generated';

export const isFullRemoteOnlyByFilterCollection = (
  filterCollection?: Array<
    JobSearchFilterCollectionFragment | JobSearchFilterCollectionSplitBenefitsFragment | null
  > | null
): boolean => {
  const remoteOptions = filterCollection?.filter((filter) => filter?.__typename === 'JobFilterRemoteOption') as
    | JobFilterRemoteOption[]
    | undefined;

  return remoteOptions?.length === 1 && remoteOptions[0].entityId.includes('FULL_REMOTE');
};

export const isFullRemoteOnlyByQueryParam = (remoteOption?: Array<string | null> | null) => {
  return remoteOption?.length === 1 && remoteOption[0]?.includes('FULL_REMOTE');
};
